import { http }       from '@/http'
import LogicException from '../errors/LogicException'

export default new class FileLoader {

  constructor () {
    this._init()
  }

  /**
   *
   * @private
   */
  _init () {
    this._fileGUID = 'FileGUID'
    this._size     = null
    this._quality  = null
    this._sizeType = 'O'
  }

  /**
   *
   * @return {*}
   */
  get (idtDocument) {
    if (!idtDocument) {
      throw new LogicException('idtDocument must be defined!')
    }

    let url = 'Document/GetFile'

    url += '?idtDocument=' + idtDocument
    url += '&fileGUID=' + this._fileGUID

    if (this._size > 0) {
      url += '&size=' + this._size
    }

    if (this._quality > 0) {
      url += '&quality=' + this._quality
    }

    if (this._sizeType) {
      url += '&sizeType=' + this._sizeType
    }

    this._init()

    return http.get(url)
  }

  /**
   *
   * @returns {string}
   * @param appName
   * @param name
   * @param year
   * @param extension
   */
  downloadUrl (appName, name, year, extension) {
    let url = 'StaticFile/DownloadFile'
    url += '?appName=' + encodeURIComponent(appName)
    url += '&fileGUID=' + encodeURIComponent(this._fileGUID)
    url += '&fileName=' + encodeURIComponent(name)
    url += '&year=' + encodeURIComponent(year)
    url += '&fileExtension=' + encodeURIComponent(extension)

    if (this._size) {
      url += '&size=' + this._size
    }

    this._init()

    return http.defaults.baseURL + '/' + url
  }

  /**
   *
   * @param value
   * @return {FileLoader}
   */
  fileGUID (value) {
    this._fileGUID = value

    return this
  }

  /**
   *
   * @param value
   * @return {FileLoader}
   */
  quality (value) {
    this._quality = value
    return this
  }

  /**
   *
   * @param value
   * @return {FileLoader}
   */
  size (value) {
    this._size = value

    return this
  }

  /**
   *
   * @param value
   * @returns {FileLoader}
   */
  sizeType (value) {
    this._sizeType = value

    return this
  }
}
